// Single source of truth for access entitlement on the frontend.
// Mirrors the backend compute_full_access / compute_single_access logic and
// prefers the backend-computed `has_full_access` flag when present.

export function hasFullAccess(user) {
  if (!user) return false;
  // Backend-computed canonical flag (present on /auth/me and login responses).
  if (user.has_full_access === true) return true;
  // Resilient fallbacks (older cached tokens / responses without the flag):
  const legacy = !!(user.is_member && user.membership_expires_at && new Date(user.membership_expires_at) > new Date());
  const hasSubscription = user.subscription_status === 'active' || user.subscription_status === 'cancelling';
  const subFull = hasSubscription && (user.access_type === 'full' || !user.access_type);
  const memberFull = !!user.is_member && user.access_type === 'full';
  const tdf = !!user.is_member && user.provisioned_by === 'tdf';
  return legacy || subFull || memberFull || tdf;
}

export function hasSingleTestAccess(user, slug) {
  if (!user || !slug) return false;
  const hasSubscription = user.subscription_status === 'active' || user.subscription_status === 'cancelling';
  return hasSubscription && user.access_type === 'single' && user.single_test_access === slug;
}

// Full entitlement snapshot used by test pages, game entry, level locking and dashboard.
export function getEntitlements(user, slug, accessStatus) {
  const fullAccess = hasFullAccess(user);
  const singleAccess = hasSingleTestAccess(user, slug);
  const unlimited = fullAccess || singleAccess;
  const hasActiveSession = !!accessStatus?.has_active_session;
  const hasCredits = (user?.free_credits > 0) || (accessStatus?.free_credits > 0);
  return {
    hasFullAccess: fullAccess,
    hasSingleTestAccess: singleAccess,
    hasUnlimitedAccess: unlimited,
    hasActiveSession,
    hasCredits,
  };
}
